import React, { useEffect } from "react";
import SolidosTableRow from "./SolidosTableRow";
import { EditableRowNames } from "../Data/SolidosData";
import SolidosTotalesRows from "./SolidosTotalesRows";
import { useFormContext, useWatch } from "react-hook-form";
import { MonthHeader } from "../../../Utils/TableComponents";

export default function SolidosMonth(props) {
    const { month, monthIndex } = props;

    const { control, setValue } = useFormContext();

    const isFirstTable = month === 'enero';

    // Sincronizar SKIM para sólidos desde Comparativo de Costo de Ventas
    const skimParaSolidosKgSecos = useWatch({
        control,
        name: `ComparativoCostoVentas.SKIMData.SKIMParaSolidos.${month}.KgSecos`,
    });
    
    // Obtener el Sub-total materia prima CostoKgSec del Comparativo de Costo de Ventas
    const LatexProcesoDataCV = useWatch({
        control,
        name: 'ComparativoCostoVentas.LatexProcesoData',
    });
    const LatexDataCostoMP = useWatch({
        control,
        name: 'ComparativoCostoMP.LatexData',
    });

    // Calcular Sub-total materia prima del Comparativo de Costo de Ventas
    const entradasMPAProduccionKgSecos = (LatexDataCostoMP && LatexDataCostoMP.SalidasAProduccion && LatexDataCostoMP.SalidasAProduccion[month]) ? LatexDataCostoMP.SalidasAProduccion[month].KgSecos : 0;
    const entradasMPAProduccionCostoKgSec = (LatexDataCostoMP && LatexDataCostoMP.SalidasAProduccion && LatexDataCostoMP.SalidasAProduccion[month]) ? LatexDataCostoMP.SalidasAProduccion[month].CostoKgSec : 0;
    const entradasMPAProduccionValorTotal = entradasMPAProduccionKgSecos * entradasMPAProduccionCostoKgSec;

    const produccionFcaKgSecos = (LatexDataCostoMP && LatexDataCostoMP.ProduccionFca && LatexDataCostoMP.ProduccionFca[month]) ? LatexDataCostoMP.ProduccionFca[month].KgSecos : 0;
    const gtosCompraCostoKgSec = (LatexProcesoDataCV && LatexProcesoDataCV.GtosDeCompraDeMP && LatexProcesoDataCV.GtosDeCompraDeMP[month]) ? LatexProcesoDataCV.GtosDeCompraDeMP[month].CostoKgSec : 0;
    const gtosCompraMPValorTotal = gtosCompraCostoKgSec * (entradasMPAProduccionKgSecos - produccionFcaKgSecos);

    const subtoTalMateriaPrimaValorTotal = entradasMPAProduccionValorTotal + gtosCompraMPValorTotal;
    const subTotalMateriaPrimaCostoKgSec = entradasMPAProduccionKgSecos > 0 ? subtoTalMateriaPrimaValorTotal / entradasMPAProduccionKgSecos : 0;

    // Sincronizar valores del SKIM del Comparativo de Costo de Ventas al de Materia Prima
    // Usar el Sub-total materia prima CostoKgSec para el SKIM
    useEffect(() => {
        const kgSecosPositivo = Math.abs(skimParaSolidosKgSecos || 0); // Convertir a positivo
        
        setValue(`ComparativoCostoMP.SolidosData.SKIMParaSolidos.${month}.KgSecos`, kgSecosPositivo);
        setValue(`ComparativoCostoMP.SolidosData.SKIMParaSolidos.${month}.CostoKgSec`, subTotalMateriaPrimaCostoKgSec);
    }, [skimParaSolidosKgSecos, subTotalMateriaPrimaCostoKgSec, month, setValue]);

    let totalKgSecos = 0;
    let totalValorTotal = 0;

    return (
        <table key={monthIndex}>
            <MonthHeader month={month} monthIndex={monthIndex} />
            <tbody>
                {EditableRowNames.map((rowName, rowIndex) => {
                    const RowData = useWatch({
                        control,
                        name: `ComparativoCostoMP.SolidosData.${rowName}`,
                    });
                    if (!RowData) return null;
                    if (!RowData[month]) return null;
                    const kgSecos = RowData[month].KgSecos;
                    const costoKgSec = RowData[month].CostoKgSec;
                    const isNegative = RowData.isNegative;
                    const total = (kgSecos * costoKgSec).toFixed(2);

                    if (isNegative) {
                        totalKgSecos -= parseFloat(kgSecos);
                        totalValorTotal -= parseFloat(total);
                    } else {
                        const kgSecosPositivo = Math.abs(parseFloat(kgSecos));
                        const totalPositivo = Math.abs(parseFloat(total));
                    
                        if (kgSecosPositivo) {
                            totalKgSecos += kgSecosPositivo;
                            totalValorTotal += totalPositivo;
                        }
                    }

                    return (
                        <SolidosTableRow key={rowIndex}
                            isFirstTable={isFirstTable}
                            rowIndex={rowIndex}
                            rowName={rowName}
                            month={month}
                            monthIndex={monthIndex}
                            total={total}
                        />
                    )
                })}
                <SolidosTotalesRows key={monthIndex}
                    monthIndex={monthIndex}
                    isFirstTable={isFirstTable}
                    month={month}
                    ctoPromedioDelInvenTotalKgSecos={totalKgSecos}
                    ctoPromedioDelInvenTotalValorTotal={totalValorTotal}
                />
            </tbody>
        </table>
    );
}
